import { FormHelperText } from "@mui/material";
import type { FieldError } from "react-hook-form";

export interface ErrorMessageProps {
  error?: FieldError | string;
  /** When true, always reserves 20px so the layout never shifts on error. */
  fixedHeight?: boolean;
}

export const BlErrorMessage = ({
  error,
  fixedHeight,
}: ErrorMessageProps): React.ReactNode => {
  const message = typeof error === "string" ? error : error?.message;

  if (!fixedHeight && !message) return null;

  return (
    <FormHelperText
      error={!!message}
      sx={{ minHeight: fixedHeight ? "20px" : undefined }}
    >
      {message ?? ""}
    </FormHelperText>
  );
};
